module.exports = __webpack_public_path__ + "static/media/squirrel.d3ee172f.svg";